// DEPENDENCIES
import React, { useState } from 'react';
// COMPONENTS
// CUSTOM COMPONENTS
import Section from '../../components/Section';
import ContentBlock from '../../components/ContentBlock';
import CustomBlock from '../../components/CustomBlock';
import ContentHeader from '../../components/ContentHeader';
import InputBlock from '../../components/InputBlock';
import SelectBlock from '../../components/SelectBlock';
import TextAreaBlock from '../../components/TextAreaBlock';
import FileUploadBlock from '../../components/FileUploadBlock';
import CheckboxBlock from '../../components/CheckboxBlock';
import Button from '../../components/Button';

const FormSamplePage = (props) => {

    const [propNameVisible, setPropNameVisible] = useState(false);
    const [isActive, setIsActive] = useState(true);
    const [isDefault, setIsDefault] = useState(false);
    const [toggle, setToggle] = useState(false);

    const companies = [
        { value: "Primtek", label: "Primtek" },
        { value: "TFG", label: "TFG" },
        { value: "", label: "" },
    ]

    const departments = [
        { value: "Accounting", label: "Accounting" },
        { value: "Sales and Marketing", label: "Sales and Marketing" },
        { value: "Software Development", label: "Software Development" },
        { value: "Human Resources", label: "Human Resources" },
    ]

    const roles = [
        { value: "Admininstrator", label: "Administrator" },
        { value: "Developer", label: "Developer" },
        { value: "Sales", label: "Sales" },
        { value: "Employee", label: "Employee" },
    ];

    const togglePropNames = () => {
        setPropNameVisible(!propNameVisible);
        setIsDefault(!isDefault);
    }

    return (
        <>
            <CustomBlock className="main-container light--bg">
                <Section>
                    <CustomBlock className="content-container--card-style">
                        <ContentHeader
                            title="Form Components"
                            headerSize="sm"
                            primaryButtonText={`${propNameVisible ? "Hide" : "Show"} Prop Names`}
                            primaryButtonBackgroundColor={propNameVisible ? "danger--bg" : "primary--bg"}
                            primaryButtonOnClick={() => togglePropNames()}
                            buttonSize="xs"
                        />
                        <Section removeContainer>
                            <ContentBlock cols={6}>
                                <InputBlock
                                    inputLabel={propNameVisible ? "inputLabel (string)" : "First Name"}
                                    placeholder={propNameVisible ? 'inputLabel="First Name"' : ""}
                                    bordered
                                />
                            </ContentBlock>

                            <ContentBlock cols={6}>
                                <InputBlock
                                    inputLabel={propNameVisible ? "Bordered <InputBlock />" : "Last Name"}
                                    placeholder={propNameVisible ? "bordered (boolean)" : ""}
                                    bordered
                                />
                            </ContentBlock>

                            <ContentBlock cols={6}>
                                <SelectBlock
                                    inputLabel={propNameVisible ? "Single Select" : "Company"}
                                    placeholder={propNameVisible ? "Single Option (default)" : ""}
                                    options={companies}
                                    bordered
                                />
                            </ContentBlock>

                            <ContentBlock cols={6}>
                                <SelectBlock
                                    inputLabel={propNameVisible ? "options [Array]" : "Department"}
                                    placeholder={propNameVisible ? "placeholder (string)" : "Choose Department"}
                                    options={departments}
                                    bordered
                                />
                            </ContentBlock>

                            <ContentBlock cols={12}>
                                <SelectBlock
                                    inputLabel={propNameVisible ? "Multi Select" : "User Role"}
                                    placeholder={propNameVisible ? "multiSelect (boolean)" : ""}
                                    options={roles}
                                    multiSelect
                                    bordered
                                />
                            </ContentBlock>

                            <ContentBlock>
                                <InputBlock
                                    inputLabel={propNameVisible ? "Disabled State" : "Access Code"}
                                    placeholder={propNameVisible ? 'inputState="disabled"' : ""}
                                    inputState="disabled"
                                    errorMessage="Invalid Address"
                                    bordered
                                />
                            </ContentBlock>

                            <ContentBlock cols={4}>
                                <InputBlock
                                    value={propNameVisible ? 'inputState="success"' : "jed.primtek"}
                                    inputLabel={propNameVisible ? "Success State" : "Username"}
                                    inputState="success"
                                    successMessage={propNameVisible ? "successMessage (string)" : "Username Available"}
                                    bordered
                                />
                            </ContentBlock>

                            <ContentBlock cols={4}>
                                <InputBlock
                                    type={propNameVisible ? "" : "password"}
                                    value={propNameVisible ? 'inputState="warning"' : "1234567890"}
                                    inputLabel={propNameVisible ? "Warning State" : "Password"}
                                    inputState="warning"
                                    warningMessage={propNameVisible ? "warningMessage (string)" : "Password not strong enough"}
                                    bordered
                                />
                            </ContentBlock>

                            <ContentBlock cols={4}>
                                <InputBlock
                                    type={propNameVisible ? "" : "password"}
                                    value={propNameVisible ? 'inputState="error"' : "1234567890"}
                                    inputLabel={propNameVisible ? "Error State" : "Confirm Password"}
                                    inputState="error"
                                    errorMessage={propNameVisible ? "errorMessage (string)" : "Passwords must match"}
                                    bordered
                                />
                            </ContentBlock>

                            <ContentBlock>
                                <InputBlock
                                    inputLabel="Employee ID Number"
                                    placeholder={propNameVisible ? 'Default Error Message = inputLabel + "is Required"' : ""}
                                    inputState="error"
                                    bordered
                                />
                            </ContentBlock>

                            <ContentBlock cols={6}>
                                <InputBlock
                                    value={propNameVisible ? "" : "johndoegmail.com"}
                                    inputLabel="Email Address"
                                    placeholder={propNameVisible ? "Custom Error Message" : ""}
                                    inputState="error"
                                    errorMessage="Please enter a valid email"
                                    bordered
                                />
                            </ContentBlock>

                            <ContentBlock cols={6}>
                                <InputBlock
                                    value={propNameVisible ? "" : "2253040614"}
                                    inputLabel={propNameVisible ? "Masked <InputBlock />" : "Phone Number"}
                                    placeholder={propNameVisible ? 'mask="(999) 999-9999"' : ""}
                                    mask="(999) 999-9999"
                                    bordered
                                />
                            </ContentBlock>

                            <ContentBlock>
                                <TextAreaBlock
                                    inputLabel={propNameVisible ? "<TextAreaBlock />" : "Additional Notes"}
                                    inputState={propNameVisible ? "warning" : ""}
                                    warningMessage="Additional notes cannot be blank"
                                    bordered
                                />
                            </ContentBlock>

                            <ContentBlock>
                                <FileUploadBlock 
                                    labelIdle={propNameVisible ? 'View documentation <a href="https://www.npmjs.com/package/react-filepond" target="_blank">here</a>' : ""}
                                />
                            </ContentBlock>

                            <ContentBlock>
                                <InputBlock
                                    placeholder={propNameVisible ? "Error message must be defined when there no inputLabel" : "Employee Indetification Number"}
                                    inputState={propNameVisible ? "error" : ""}
                                />
                            </ContentBlock>

                            <ContentBlock cols={6}>
                                <InputBlock
                                    placeholder={propNameVisible ? "no inputLabel and border" : "First Name"}
                                />
                            </ContentBlock>

                            <ContentBlock cols={6}>
                                <InputBlock
                                    placeholder={propNameVisible ? "no inputLabel and border" : "Last Name"}
                                />
                            </ContentBlock>

                            <ContentBlock cols={4}>
                                <InputBlock
                                    placeholder={propNameVisible ? "no inputLabel and border" : "Date of Birth"}
                                    mask="99/99/9999"
                                />
                            </ContentBlock>

                            <ContentBlock cols={4}>
                                <InputBlock
                                    placeholder={propNameVisible ? "no inputLabel and border" : "Email Address"}
                                />
                            </ContentBlock>

                            <ContentBlock cols={4}>
                                <InputBlock
                                    placeholder={propNameVisible ? "no inputLabel and border" : "Phone Number"}
                                    mask="(999) 999-9999"
                                />
                            </ContentBlock>

                            <ContentBlock className="padding-vertical">
                                <CheckboxBlock
                                    label={propNameVisible ? "Nothing fancy. It's just a checkbox ¯\\\_(ツ)_/¯" : "Select category as active"}
                                    id="is-active-checkbox"
                                    defaultChecked
                                />

                                <CheckboxBlock
                                    label={propNameVisible ? 'Always set an id : id="what-is-it-for-checkbox"' : "Select as default category"}
                                    id="default-category-checkbox"
                                    onChange={() => setIsDefault(!isDefault)}
                                    checked={isDefault}
                                />

                                {
                                    propNameVisible ?
                                        <CheckboxBlock
                                            label='Toggle state using "onChange" and "checked" props'
                                            id="state-toggle-checkbox"
                                            defaultChecked
                                        /> : <></>
                                }
                            </ContentBlock>


                            <CustomBlock className="content-container--actions">
                                <Button
                                    text="Cancel"
                                    className="danger--bg fit-content"
                                />
                                <Button
                                    text="Save"
                                    className="success--bg fit-content"
                                    loading={propNameVisible}
                                />
                            </CustomBlock>
                        </Section>
                    </CustomBlock>
                </Section>
            </CustomBlock>
        </>
    );
}

export default FormSamplePage;